import { render, staticRenderFns } from "./TagContainer.vue?vue&type=template&id=6a1e82d0&scoped=true&"
import script from "./TagContainer.vue?vue&type=script&lang=js&"
export * from "./TagContainer.vue?vue&type=script&lang=js&"
import style0 from "./TagContainer.vue?vue&type=style&index=0&id=6a1e82d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e82d0",
  null
  
)

export default component.exports